;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Progress } from 'reactstrap';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

type Props = {
  dictionary: Partial<Dictionaries>;
  step: number;
};
function ProfileModalProgress({ step, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const totalSteps = 6;
  return (
    <div className="mb-4 p-4">
      <Progress className="my-3" value={(100 / totalSteps) * step} color="accent" />
      <div className="d-flex justify-content-center">
        <small>{formatMessage({ id: 'step-count' }, { step, totalSteps })}</small>
      </div>
    </div>
  );
}

export default ProfileModalProgress;
